module.exports = __webpack_public_path__ + "static/media/cnq.59ac6c9c.png";